export default __webpack_public_path__ + "static/beige-nr-natural-cork-3442a026d66c974c38e9f8f62b87d73b.jpg";